const load = () => {
  return {
    page_title: "Sales"
  };
};
export {
  load
};
//# sourceMappingURL=_page.ts.js.map
